import { isDsV2 } from "../../core/utils";
import { Constants } from "../../shared/constants/constants";
import type { SearchTermTypes } from "../../shared/models";

export const BAD_MYSQL_WORDS = [
  "a",
  "about",
  "an",
  "are",
  "as",
  "at",
  "be",
  "by",
  "com",
  "de",
  "en",
  "for",
  "from",
  "how",
  "i",
  "in",
  "is",
  "it",
  "la",
  "of",
  "on",
  "or",
  "that",
  "the",
  "this",
  "to",
  "was",
  "what",
  "when",
  "where",
  "who",
  "will",
  "with",
  "und",
  "the",
  "www",
];

export const BLOCKED_SEARCH_CHARS = ["\\"];

export const hasBadWord = (str: string) => {
  const badWordArray = str.split(" ");
  if (badWordArray.length > 1) {
    return;
  }

  const index = BAD_MYSQL_WORDS.findIndex((val) => val === badWordArray[0] || val.includes(badWordArray[0]));

  return index > -1;
};

type CategoryTypes = {
  type: SearchTermTypes;
  icon: string;
  text: string;
  active: boolean;
  subCategories?: {
    type:
      | "NKPI"
      | "SKPI"
      | "EKPI"
      | "UAE"
      | "OPM"
      | "SRVKPI"
      | "MOKPI"
      | "IPTKPI"
      | "MTKPI"
      | "NTKPI"
      | "DTKPI"
      | "IMKPI"
      | "AIKPI"
      | "TRANSFORMATIONAL_PROJECT"
      | "TRANSFORMATIONAL_MILESTONE"
      | "ANNUAL_MEETING_PROJECT"
      | "ANNUAL_MEETING_MILESTONE"
      | "INTERNATIONAL_PROJECT"
      | "INTERNATIONAL_MILESTONE"
      | "REGULAR_TASK"
      | "STRATEGIC_PROJECT"
      | "STRATEGIC_ACTIVITIES"
      | "PROJECTACTIVITY"
      | "OPERATIONAL_ACTIVITIES"
      | "TRANSFORMATIONAL_PROJECT_NEW"
      | "TRANSFORMATIONAL_PROJECT_MILESTONE_NEW";
    icon: string;
    text: string;
    active: boolean;
  }[];
};
export const getSearchCategories = (): CategoryTypes[] => [
  {
    type: "GOVERNMENT_DIRECTION",
    text: "directions.government_directions",
    icon: "adaa-icon-console_govDirections",
    active: true,
  },
  {
    type: "SUB_GOVERNMENT_DIRECTION",
    text: "directions.sub_government",
    icon: "fa-solid fa-repeat",
    active: true,
  },
  {
    type: "INITIATIVE",
    text: isDsV2() ? "national_projects.projects" : "initiatives.initiatives",
    icon: "adaa-icon-console_initiatives",
    active: true,
  },
  {
    type: "KPI",
    text: "kpi.kpis",
    icon: "adaa-icon-console_kpis",
    active: true,
    subCategories: [
      {
        type: "DTKPI",
        text: "dtkpi.dtkpi",
        icon: "adaa-icon-console_dkpi",
        active: true,
      },
      {
        type: "NTKPI",
        text: "ntkpi.ntkpi",
        icon: "adaa-icon-console_nkpi",
        active: true,
      },
      {
        type: "MOKPI",
        text: "mokpi.mokpi",
        icon: "adaa-icon-console_mokpi",
        active: true,
      },
      {
        type: "IPTKPI",
        text: "breadcrumbs.iptkpi_module.list",
        icon: "adaa-icon-console_iptkpi",
        active: true,
      },
      {
        type: "MTKPI",
        text: "mtkpi.mtkpi",
        icon: "adaa-icon-console_mtkpi",
        active: true,
      },
      {
        type: "IMKPI",
        text: "imkpi.imkpi",
        icon: "adaa-icon-console_imkpi",
        active: true,
      },
      {
        type: "AIKPI",
        text: "aikpi.aikpi",
        icon: "adaa-icon-console_aikpi",
        active: true,
      },
      {
        type: "SKPI",
        text: "skpi.skpi",
        icon: "adaa-icon-console_skpi",
        active: true,
      },
      {
        type: "EKPI",
        text: "ekpi.ekpi",
        icon: "adaa-icon-console_ekpi",
        active: true,
      },
      {
        type: "SRVKPI",
        text: "srvkpi.srvkpi",
        icon: "adaa-icon-console_srvkpi",
        active: true,
      },
      {
        type: "NKPI",
        text: "nkpi.nkpi",
        icon: "adaa-icon-console_nkpi",
        active: true,
      },
      {
        type: "UAE",
        text: "uae.uae",
        icon: "adaa-icon-console_dkpi",
        active: true,
      },
      {
        type: "OPM",
        text: "opm.opm_measure",
        icon: "adaa-icon-console_opm",
        active: true,
      },
    ],
  },
  {
    type: "OBJECTIVE",
    text: "objectives.objective",
    icon: "adaa-icon-console_objectives",
    active: true,
  },
  {
    type: "TASK",
    text: "tasks.tasks",
    icon: "fa-solid fa-file-circle-check",
    active: true,
  },
  {
    type: "SERVICE",
    text: "search.services",
    icon: "adaa-icon-console_services",
    active: true,
  },
  {
    type: "ATTACHMENT",
    text: "services.attachments",
    icon: "fa-solid fa-paperclip",
    active: true,
  },
  {
    type: "TAG",
    text: "plusbutton.tags",
    icon: "fa-solid fa-tag",
    active: true,
  },
  {
    type: "FORMULA",
    text: "formulas.formula_console_icon",
    icon: "adaa-icon-console_formulas",
    active: true,
  },
  {
    type: "ACTIVITY",
    text: "tasks.activity",
    icon: "adaa-icon-console_activities",
    active: true,
  },
  {
    type: "USER",
    text: "user.console",
    icon: "adaa-icon-console_users",
    active: true,
  },
  {
    type: "MPROJECT",
    text: "national_projects.console_title",
    icon: "adaa-icon-console_national_projects",
    active: true,
    subCategories: [
      {
        type: "TRANSFORMATIONAL_PROJECT",
        text: "national_strategies.initiatives",
        icon: "adaa-icon-console_national_projects_M1",
        active: true,
      },
      {
        type: "TRANSFORMATIONAL_MILESTONE",
        text: "national_projects.milestones",
        icon: "adaa-icon-console_projectMilestones",
        active: true,
      },
    ],
  },
  {
    type: "AGM",
    text: "annual_meetings.page_title",
    icon: "adaa-icon-console_agm",
    active: true,
    subCategories: [
      {
        type: "ANNUAL_MEETING_PROJECT",
        text: "national_strategies.initiatives",
        icon: "adaa-icon-console_national_projects_M1",
        active: true,
      },
      {
        type: "ANNUAL_MEETING_MILESTONE",
        text: "national_projects.milestones",
        icon: "adaa-icon-console_projectMilestones",
        active: true,
      },
    ],
  },
  {
    type: "INTProject",
    text: "international_projects.title",
    icon: "adaa-icon-console_intp_projects",
    active: true,
    subCategories: [
      {
        type: "INTERNATIONAL_PROJECT",
        text: "international_projects.projects.title",
        icon: "adaa-icon-console_intp_projects",
        active: true,
      },
      {
        type: "INTERNATIONAL_MILESTONE",
        text: "international_projects.milestones.title",
        icon: "adaa-icon-console_intp_milestones",
        active: true,
      },
    ],
  },
  {
    type: "PROJECT",
    text: "national_projects.projects",
    icon: "adaa-icon-console_intp_projects",
    active: true,
    subCategories: [
      {
        type: "REGULAR_TASK",
        text: "breadcrumbs.initiative_module.regular_task_list",
        icon: "adaa-icon-console_initiatives",
        active: true,
      },
      {
        type: "STRATEGIC_PROJECT",
        text: "breadcrumbs.initiative_module.strategic_project_list",
        icon: "adaa-icon-console_initiatives",
        active: true,
      },
      {
        type: "TRANSFORMATIONAL_PROJECT_NEW",
        text: "national_projects.project_names",
        icon: "adaa-icon-console_initiatives",
        active: true,
      },
    ],
  },
  {
    type: "PROJECTACTIVITY",
    text: "activities.title",
    icon: "adaa-icon-console_activities",
    active: true,
    subCategories: [
      {
        type: "STRATEGIC_ACTIVITIES",
        text: "breadcrumbs.activity.strategic_list",
        icon: "adaa-icon-console_activities",
        active: true,
      },
      {
        type: "OPERATIONAL_ACTIVITIES",
        text: "breadcrumbs.activity.operational_list",
        icon: "adaa-icon-console_activities",
        active: true,
      },
      {
        type: "TRANSFORMATIONAL_PROJECT_MILESTONE_NEW",
        text: "national_projects.milestones",
        icon: "adaa-icon-console_initiatives",
        active: true,
      },
    ],
  },
];

export const getServiceName = (itemType: number, id: number) => {
  switch (itemType) {
    case Constants.CONSTANT_AUXSERVICE:
      return {
        text: "services.auxiliary_service",
        url: ["/console", "services", "aux-service", id],
      };
    case Constants.CONSTANT_VARSERVICE:
      return {
        text: "services.variation_service",
        url: ["/console", "services", "var-service", id],
      };
    default:
      return {
        text: "services.main_service",
        url: ["/console", "services", "main-service", id],
      };
  }
};

export const isSubKPIType = (t: string) =>
  t?.toLowerCase() === "dtkpi" ||
  t?.toLowerCase() === "ekpi" ||
  t?.toLowerCase() === "mokpi" ||
  t?.toLowerCase() === "iptkpi" ||
  t?.toLowerCase() === "mtkpi" ||
  t?.toLowerCase() === "imkpi" ||
  t?.toLowerCase() === "aikpi" ||
  t?.toLowerCase() === "nkpi" ||
  t?.toLowerCase() === "ntkpi" ||
  t?.toLowerCase() === "opm" ||
  t?.toLowerCase() === "skpi" ||
  t?.toLowerCase() === "srvkpi" ||
  t?.toLowerCase() === "uae";

export const isSubIPTType = (t: string) =>
  t?.toLowerCase() === "international_project" || t?.toLowerCase() === "international_milestone";

export const isProjectType = (t: string) =>
  t?.toLowerCase() === "transformational_project" ||
  t?.toLowerCase() === "transformational_milestone" ||
  t?.toLowerCase() === "annual_meeting_project" ||
  t?.toLowerCase() === "annual_meeting_milestone";

export const getKpiName = (itemType: number) => {
  switch (itemType) {
    case Constants.KPI_TYPE.NKPI:
      return "nkpi.nkpi";
    case Constants.KPI_TYPE.SKPI:
      return "skpi.skpi";
    case Constants.KPI_TYPE.EKPI:
      return "ekpi.ekpi";
    case Constants.KPI_TYPE.OPM:
      return "opm.opm";
    case Constants.KPI_TYPE.UAE:
      return "uae.uae";
    case Constants.KPI_TYPE.SRVKPI:
      return "srvkpi.srvkpi";
    case Constants.KPI_TYPE.MOKPI:
      return "mokpi.mokpi";
    case Constants.KPI_TYPE.IPTKPI:
      return "breadcrumbs.iptkpi_module.list";
    case Constants.KPI_TYPE.MTKPI:
      return "mtkpi.mtkpi";
    case Constants.KPI_TYPE.IMKPI:
      return "imkpi.imkpi";
    case Constants.KPI_TYPE.AIKPI:
      return "aikpi.aikpi";
    case Constants.KPI_TYPE.NTKPI:
      return "ntkpi.ntkpi";
    case Constants.KPI_TYPE.DTKPI:
      return "dtkpi.dtkpi";
    default:
      return "";
  }
};

export const getKpiUrl = (itemType: number, itemId: number): string[] => {
  const url: string[] = ["/console", "kpi"];
  const id = `${itemId}`;
  switch (itemType) {
    case Constants.KPI_TYPE.NKPI:
      url.push("nkpi", id);
      break;
    case Constants.KPI_TYPE.SKPI:
      url.push("skpi", id);
      break;
    case Constants.KPI_TYPE.EKPI:
      url.push("ekpi", id);
      break;
    case Constants.KPI_TYPE.OPM:
      url.push("opm", id);
      break;
    case Constants.KPI_TYPE.UAE:
      url.push("uae", id);
      break;
    case Constants.KPI_TYPE.SRVKPI:
      url.push("srvkpi", id);
      break;
    case Constants.KPI_TYPE.MOKPI:
      url.push("mokpi", id);
      break;
    case Constants.KPI_TYPE.IPTKPI:
      url.push("iptkpi", id);
      break;
    case Constants.KPI_TYPE.MTKPI:
      url.push("mtkpi", id);
      break;
    case Constants.KPI_TYPE.IMKPI:
      url.push("imkpi", id);
      break;
    case Constants.KPI_TYPE.AIKPI:
      url.push("aikpi", id);
      break;
    case Constants.KPI_TYPE.NTKPI:
      url.push("ntkpi", id);
      break;
    case Constants.KPI_TYPE.DTKPI:
      url.push("dtkpi", id);
      break;
    default:
      break;
  }
  return url;
};

export const getActivityUrl = (itemId: number, subType: number | undefined) => {
  const url: string[] = ["/console", "activities"];
  if (!isDsV2()) url.push(`${itemId}`);
  else url.push(subType === Constants.ACTIVITY_TYPES.STRATEGIC_ACTIVITY ? "strategic" : "operational", `${itemId}`);
  return url;
};

export const getProjectsUrl = (itemId: number, subType: number | undefined) => {
  const url: string[] = ["/console", "initiatives"];
  if (!isDsV2()) url.push(`${itemId}`);
  else
    url.push(
      subType === Constants.INITIATIVE_TYPES.STRATEGIC_PROJECT ? "strategic-projects" : "regular-tasks",
      `${itemId}`
    );

  return url;
};
